import React from 'react'
import styles from './invitation.module.scss'

import michael from '../../assets/michael.jpg'
import michaelWebp from '../../assets/michael.webp'

import piotr from '../../assets/piotr.jpg'
import piotrWebp from '../../assets/piotr.webp'

import ImgWithFallback from '../ImgWithFallback'

const Invitation = () => {
    return (
        <div className={`${styles.invitation} ${styles.container}`}>
            <div className={styles.head}>
                <h2 className={styles.title}>Do you need a broader set of audit services?</h2>
                <p>
                    Not everything can be checked automatically via various tools, and that’s why
                    our experts are ready to perform 
                    a full, deep audit of your e-shop or your entire commerce
                    and mobile ecosystem.
                </p>
                <p>
                    Contact our experts and earn more money from mobile customers.
                </p>
                <a href='mailto:contact@e-point.com' className={styles.btnDecoratedBorder}>Contact experts</a>
            </div>
            <div className={styles.body}>
                    <div className={styles.expert}>
                        <div className={styles.expertHead}>
                            <h3 className={`${styles.subTitle} ${styles.textCenter}`}>Michael</h3>
                            <a className={styles.phone} href="tel:+48512152876">+48 512 152 876</a>
                            <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/in/michalszklarski/' className={styles.btnDecoratedBorder}>Linkedin</a>
                        </div>
                        <div className={styles.expertBody}>
                            <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/in/michalszklarski/'>
                            <ImgWithFallback
                                src={michaelWebp}
                                fallback={michael}
                                alt="Michał Szklarski"
                            />
                            </a>
                        </div>
                    </div>
                    <div className={styles.expert}>
                        <div className={styles.expertHead}>
                            <h3 className={`${styles.subTitle} ${styles.textCenter}`}>Peter</h3>
                            <a className={styles.phone} href="tel:+48502244320">+48 502 244 320</a>
                            <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/in/piotrrozycki/' className={styles.btnDecoratedBorder}>Linkedin</a>
                        </div>
                        <div className={styles.expertBody}>
                            <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/in/piotrrozycki/'>
                            <ImgWithFallback
                                src={piotrWebp}
                                fallback={piotr}
                                alt="Piotr Różycki"
                            />
                            </a>
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default Invitation
